import React, { useState } from 'react';
import * as styles from './styles.scss';

const Tabs = ({ tabs, selected = 0, className }) => {
    const [current, setCurrent] = useState(selected);

    return (
        <div className={className}>
            <div className={styles.tabs}>
                {
                    tabs.map(({ title, icon }, index) => (
                        <button
                            key={index}
                            { ...(current === index ? { className: styles.selected } : {}) }
                            onClick={() => setCurrent(index)}
                        >
                            {icon}{title}
                        </button>
                    ))
                }
            </div>
            {
                tabs.map(({ content }, index) => (
                    <div
                        key={index}
                        className={`${styles.tab}${current === index ? ` ${styles.active}` : ''}`}
                    >
                        {content}
                    </div>
                ))
            }
        </div>
    )
};

export default Tabs;
